module.exports = __webpack_public_path__ + "img/American_Credit_Equipment_Financing_Loan_Limit_High.8c8d48f.png";